(function () {
  'use strict';

  if (window.paymentWidgetsCompactV1Initialized) return;
  window.paymentWidgetsCompactV1Initialized = true;

  var STYLE_ID = 'payment-widgets-compact-v1';

  var TABBY_CSS = [
    '[class*="SnippetWrapper__SnippetWrapper__Content--"]{min-height:0!important}',
    '[class*="SnippetDefault__SnippetDefault__Content--"]{align-items:center!important;min-height:60px!important;padding:12px 16px!important}',
    '[class*="SnippetContent__SnippetContent--"]{display:block!important;flex:1 1 auto!important;min-width:0!important;max-height:34px!important;margin:0!important;margin-inline-end:12px!important;overflow:hidden!important;line-height:17px!important}',
    '[class*="SnippetContent__SnippetContent__Text--"]{display:inline!important;font-size:14px!important;line-height:17px!important}',
    '[class*="SnippetContent__SnippetContent__Text--"]>*{display:inline!important;font-size:14px!important;line-height:17px!important}',
    '[class*="SnippetContent__SnippetContent__Link--"]{display:inline!important;margin:0!important;margin-inline-start:4px!important;white-space:nowrap!important}',
    '[class*="SnippetDefault__SnippetDefault__Content--"]>[class*="styles__containerPortal--"]{align-self:center!important;flex:0 0 70px!important}',
    '@media(max-width:900px){[class*="SnippetDefault__SnippetDefault__Content--"]{min-height:56px!important;padding:10px 12px!important}[class*="SnippetContent__SnippetContent--"]{max-height:32px!important;margin-inline-end:8px!important;line-height:16px!important}[class*="SnippetContent__SnippetContent__Text--"],[class*="SnippetContent__SnippetContent__Text--"]>*{font-size:12.5px!important;line-height:16px!important}[class*="SnippetDefault__SnippetDefault__Content--"]>[class*="styles__containerPortal--"]{flex-basis:64px!important}}'
  ].join('');

  var TAMARA_CSS = [
    '.tamara-summary-widget__container{font-size:14px!important;line-height:18px!important;padding:11px 16px!important}',
    '.summary-widget-content.badge-right{align-items:center!important;gap:12px!important}',
    '.summary-widget-content .content-wrapper{display:block!important;flex:1 1 auto!important;min-width:0!important;max-height:36px!important;overflow:hidden!important;line-height:18px!important}',
    '.summary-widget-content .content-wrapper>*{display:inline!important;font-size:inherit!important;line-height:inherit!important}',
    '.summary-widget-content .content-wrapper .tamara-summary-widget__amount{display:inline-flex!important;vertical-align:middle!important}',
    '.tamara-inline-learn-more-link{display:inline!important;margin-inline-start:4px!important;white-space:nowrap!important}',
    '.summary-widget-content .badge-wrapper{align-self:center!important;flex:0 0 auto!important}',
    '@media(max-width:900px){.tamara-summary-widget__container{font-size:12.5px!important;line-height:16px!important;padding:10px 12px!important}.summary-widget-content.badge-right{gap:8px!important}.summary-widget-content .content-wrapper{max-height:32px!important;line-height:16px!important}.tamara-inline-badge{max-width:64px!important;height:auto!important}}'
  ].join('');

  function ensureStyle(root, provider, css) {
    if (!root) return;
    var id = STYLE_ID + '-' + provider;
    if (!root.getElementById(id)) {
      var style = document.createElement('style');
      style.id = id;
      style.textContent = css;
      root.appendChild(style);
    }
    if (!root._paymentWidgetsCompactObserver && window.MutationObserver) {
      root._paymentWidgetsCompactObserver = new MutationObserver(function () {
        if (!root.getElementById(id)) ensureStyle(root, provider, css);
      });
      root._paymentWidgetsCompactObserver.observe(root, { childList: true, subtree: false });
    }
  }

  function scanShadowRoots(root, provider, css) {
    if (!root || !root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll('*'), function (element) {
      if (element.shadowRoot) {
        ensureStyle(element.shadowRoot, provider, css);
        scanShadowRoots(element.shadowRoot, provider, css);
      }
    });
  }

  function applyCompactStyles() {
    var tabby = document.getElementById('TabbyPromo');
    if (tabby) scanShadowRoots(tabby, 'tabby', TABBY_CSS);

    Array.prototype.forEach.call(document.querySelectorAll('tamara-widget'), function (widget) {
      if (widget.shadowRoot) {
        ensureStyle(widget.shadowRoot, 'tamara', TAMARA_CSS);
        scanShadowRoots(widget.shadowRoot, 'tamara', TAMARA_CSS);
      }
    });
  }

  var queued = false;
  function scheduleApply() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      applyCompactStyles();
    });
  }

  if (window.MutationObserver) {
    new MutationObserver(scheduleApply).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('shopify:section:load', scheduleApply);
  window.addEventListener('pageshow', scheduleApply);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleApply, { once: true });
  } else {
    scheduleApply();
  }

  [100, 300, 700, 1500, 3000, 5000].forEach(function (delay) {
    window.setTimeout(applyCompactStyles, delay);
  });
})();